module.exports = __webpack_public_path__ + "static/styled-components-379c5ded0bef234461b35c1c086ba93f.png";